module.exports = __webpack_public_path__ + "img/n22.141925de.jpg";